import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { FormSelectField } from '../../../../common/form/form-select-field';
import { FormNumberField } from '../../../../common/form/form-number-field';
import { InputFormCheckbox } from '../../../../common/form/form-parts/input-form-checkbox';
import { FormLabel } from '../../../../common/form/form-parts/form-label';


interface ShiftPeriodFiltersInputProps {
  isDisabled?: boolean,
  id: string,
  value: ShiftPeriodFilter[],
  name: string,
  label?: string,
  onChange: Dispatch<{target: {name: string, value: ShiftPeriodFilter[]}}>,
}

enum SHIFT_PERIOD_UNITS {
  D = 'D',
  H = 'H'
}

interface ShiftPeriodFilter {
  unit: SHIFT_PERIOD_UNITS,
  value: number,
  default: boolean,
}

const ShiftPeriodFiltersInput: React.FC <ShiftPeriodFiltersInputProps> = ({ id, name, value, onChange, isDisabled = false, label }) => {
  const { t } = useTranslation();
  const unitSelectValues = Object.values(SHIFT_PERIOD_UNITS).map((u) => ({ value: u, label: u}));

  const onUnitChange = (val:SHIFT_PERIOD_UNITS, ind:number) => {
    const newPeriods = [...value];
    newPeriods[ind].unit = val;

    onChange({target: {name: name, value: newPeriods}});
  };

  const onValueChange = (val:number, ind:number) => {
    const newPeriods = [...value];
    newPeriods[ind].value = val;

    onChange({target: {name: name, value: newPeriods}});
  };

  const onDefaultChange = (ind:number) => {
    if(value[ind].default) {
      return;
    }
    const newPeriods = value.map((period,i) => i !== ind ? {...period, default: false} : {...period, default: true});

    onChange({target: {name: name, value: newPeriods}});
  };

  return (
    <div id={id} className='flex flex-col'>
      {label && (
        <FormLabel id={`label_${id}`} label={label} isDisabled={isDisabled} />
      )}
      {
        value.map((_, index) => (
          <div className='flex gap-2 justify-end-safe items-center' key={index}>
            <FormSelectField
              key={index}
              classname={'w-1/3'}
              id={`period-unit_${index}`}
              name='unit'
              label={t('common.unit')}
              value={value[index].unit}
              isDisabled={isDisabled}
              options={unitSelectValues}
              handleChange={({ target: { value } }) => onUnitChange(value, index)}
            />
            <FormNumberField
              classname={'w-1/3'}
              id={`period-value_${index}`}
              label={t('common.value')}
              isDisabled={isDisabled}
              value={value[index].value}
              name={'period-value'}
              handleChange={({ target: { value } }) => {
                const numValue = parseInt(value, 10);
                if (!isNaN(numValue) && numValue >= 0) {
                  onValueChange(numValue, index);
                }
              }}
            />
            <InputFormCheckbox
              id={'default-value-' + index}
              label={t('common.default')}
              name='is-default-period'
              isChecked={value[index].default}
              isDisabled={isDisabled}
              handleChange={() => onDefaultChange(index)}
            />
          </div>
        ))
      }
    </div>
  );
};

export { ShiftPeriodFiltersInput, SHIFT_PERIOD_UNITS };
